
export default function useStoryblokAdmin() {
  const isInStoryblokAdmin = (): boolean => {
    try {
      const route = useRoute();
      if (route.query && route.query._storyblok && route.query._storyblok !== '') {
        return true;
      }
      return false;
    } catch (e) {
      console.log(e);
      return false;
    }
  };

  const storyblokReleaseId = () => {
    try {
      const route = useRoute();
      return route.query?._storyblok_release ?? null;
    } catch (e) {
      console.log(e);
      return null;
    }

  };

  return {
    isInStoryblokAdmin,
    storyblokReleaseId,
  };
}
